<template>
  <div>
    <button class="modal__close" @click.prevent="$emit('close')">
      X
    </button>
    <div class="modal-body">
      <h3>Consent to the Provision and Processing of Personal Data</h3>
      <p>
        I hereby voluntarily give my consent to the provision and processing of personal data in accordance with EU Regulation 679/2016 to the extent of the data contained in this form, namely my first name, last name, email address, and telephone number, by the controller, i.e., Europe Bike Tours s.r.o., Mařákova 263/3, 160 00 Prague 6, Czech Republic (hereinafter referred to as "the processor").
      </p>
      <p>
        I provide my consent for the purposes of processing reservations, electronic communication, i.e., providing information by email or telephone, sending commercial communications via electronic means according to Act No. 480/2004 Coll., on certain services of the information society, as amended.
      </p>
      <h3>The personal data will be processed by the controller both manually and automatically.</h3>
      <p>
        I hereby acknowledge that the controller is obliged, upon my request, to provide me with information about the processing of my personal data, its purpose, the personal data that are being processed, including information about their source, the nature of any automated processing, and the recipients of the personal data, i.e., those to whom my personal data have been disclosed.
      </p>
      <p>
        Furthermore, I acknowledge that I have the right to request an explanation from the controller regarding the processing of my personal data in case I find or believe that the processing is not being conducted properly, and also the right to request the controller to rectify this situation, especially by blocking, correcting, supplementing, or erasing personal data.
      </p>
      <p>
        I provide my consent voluntarily and acknowledge that I have the right to withdraw it at any time. This consent is granted for a period of 60 months from its provision.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GdprModal"
};
</script>

<style type="sass">
.modal__close {
  color: #fff;
  background-color: #FFB541;
  font-weight: bold;
  position: absolute;
  right: 10px;
  top: 10px;
  border: 0;
  width: 40px;
  height: 40px;
  z-index: 1000;
  border-radius: 100% !important;

}
.v--modal {
  border-radius: 20px !important;
  z-index: 1000;
  margin-top: 50px;
}
.modal-body {
  padding: 40px !important;
}
.modal-body p {
  font-size: 14px;
}
.modal-body h3 {
  margin: 1.5rem 0 0.5rem;
}
</style>
